import Book from './Book'
import Vpr from './Vpr'
import router from '@/router'
import {
  USER_ITEM_TYPE_BOOK,
  USER_ITEM_TYPE_VPR,
  MARKET_BUY_BUTTON_LABEL_DEFAULT,
  MARKET_URL_DEFAULT
} from '@/config'

const ERROR_WRONG_TYPE = 'Unknown UserItem type'
const ERROR_WRONG_DATA_ACCESS = 'Access to incorrect UserItem\'s data is denied'

export default class UserItem {
  constructor (data, progresItem = null) {
    if (!data || !data.data || !data.type) throw new Error('Invalid UserItem data.')

    switch (data.type) {
      case USER_ITEM_TYPE_BOOK:
        this.data = new Book(data.data, progresItem)
        this.type = USER_ITEM_TYPE_BOOK
        break

      case USER_ITEM_TYPE_VPR:
        this.data = new Vpr(data.data, progresItem)
        this.type = USER_ITEM_TYPE_VPR
        break

      default:
        throw new Error(ERROR_WRONG_TYPE)
    }

    this.bought = data.bought ?? false

    this.favorite = data.favorite ?? false

    this.purchaseText = data.purchase_text || MARKET_BUY_BUTTON_LABEL_DEFAULT

    this.purchaseLink = data.purchase_link || MARKET_URL_DEFAULT

    this.nomenklatura = data.nomenklatura || null

    this.price = data.cost || 1489

    this.oldPrice = data.oldPrice || 0
  }

  get id () {
    return this.data.id
  }

  get isBook () {
    return this.type === USER_ITEM_TYPE_BOOK
  }

  get isVpr () {
    return this.type === USER_ITEM_TYPE_VPR
  }

  get book () {
    if (!this.isBook) throw new Error(ERROR_WRONG_DATA_ACCESS)
    return this.data
  }

  get vpr () {
    if (!this.isVpr) throw new Error(ERROR_WRONG_DATA_ACCESS)
    return this.data
  }

  goToContents () {
    switch (this.type) {
      case USER_ITEM_TYPE_BOOK:
        router.push({ name: 'Book', params: { id: this.id } })
        return

      case USER_ITEM_TYPE_VPR:
        router.push({ name: 'VprContents', params: { id: this.id } })
        return

      default:
        throw new Error(ERROR_WRONG_TYPE)
    }
  }

  goToPurchaseLink () {
    window.open(this.purchaseLink, { target: '_blank' })
  }
}
